import React from "react";
import { styled } from "@mui/material/styles";
import { Paper, Stack, Typography } from "@mui/material";
import HeightBox from "../HeightBox";

const Container = styled(Paper)(({ theme }) => ({
  backgroundColor: "transparent",
}));

const CustomTypography = styled(Typography)(({ theme }) => ({
  fontSize: 20,
  fontWeight: "bold",
}));

export const LetterPrintOutEng = React.forwardRef((props, ref) => {
  const { formValues } = props;
  const greeting = formValues.greeting;
  const title = formValues.title;
  const customerName = formValues.customerName;
  const letBody = formValues.letterBody;
  const signatureText = formValues.signatureText;
  return (
    <Container elevation={0} ref={ref}>
      <style type="text/css" media="print">
        {"\
   @page { size: portrait; }\
"}
      </style>
      {/* <img
        // src="/images/letter.jpg"
        alt=""
        style={{
          position: "absolute",
          height: "100%",
          width: "100%",
          zIndex: -1,
        }}
      /> */}
      <HeightBox height={265} />
      <Stack direction="row" spacing={2}>
        <Stack direction="column" spacing={2} style={{ marginLeft: 100 }}>
          <HeightBox height={4} />
          {/* <CustomTypography>{greeting}</CustomTypography> */}
          <p
            // className="text-muted"
            style={{ color: "rgba(0,0,0,0.9)", lineHeight: "0.6em" }}
            dangerouslySetInnerHTML={{
              __html: greeting,
            }}
          ></p>
          <HeightBox height={3} />
          <b>
            <u>
              <p
                // className="text-muted"
                style={{
                  marginTop: -40,
                  marginLeft: -50,
                  color: "rgba(0,0,0,0.9)",
                  textAlign: "center",
                  width: "18cm",
                }}
              >
                {title}
              </p>
            </u>
          </b>
          <HeightBox height={10} />

          <HeightBox height={2} />
          <p
            // className="text-muted"
            style={{ color: "rgba(0,0,0,0.9)", lineHeight: "1.1em", width: "16.2cm" }}
            dangerouslySetInnerHTML={{
              __html: letBody,
            }}
          ></p>

          <p
            // className="text-muted"
            style={{ color: "rgba(0,0,0,0.9)" }}
          >
            THANK YOU,
            <br /> BEST REGARDS,
            {"     "}
            <HeightBox height={4} />
            <br />
          </p>
          <p
            // className="text-muted"
            style={{ color: "rgba(0,0,0,0.9)" }}
          >
            <p
            // className="text-muted"
            style={{ color: "rgba(0,0,0,0.9)", lineHeight: "1.1em", width: "16.2cm" }}
            dangerouslySetInnerHTML={{
              __html: signatureText,
            }}
          ></p>

          </p>
        </Stack>
      </Stack>
    </Container>
  );
});
